export default __webpack_public_path__ + "static/media/BG_dark_Blue.e3a7a5f2.svg";